import {
    Form,
} from "react-bootstrap";
import {
    SubmitButton,
} from "./components/forms";
import {useForm} from "react-hook-form";
import {fetchForms, postForms} from "./utils/fetch";
import {useEffect, useState} from "react";
import {formEnum} from "./formEnum";
import {useLocation} from "react-router-dom";
import {CgDanger} from "react-icons/cg";
import {ErrorMessage} from '@hookform/error-message';
import HelpText from "./components/HelpText";


function App() {

    const {
        register,
        handleSubmit,
        formState: {errors}
    } = useForm();

    const [formFields, setFormFields] = useState([])
    const [submitStatus, setSubmitStatus] = useState("")

    const location = useLocation();
    useEffect(() => {
        const getFields = async () => {
            const form = await fetchForms(location.pathname)
            setFormFields(form.fields)
        }
        getFields()
    }, [location.pathname])

    const onSubmit = async (data) => {
        setSubmitStatus("submitting")
        const res = await postForms(
            location.pathname,
            data,
        )
        if (res.status === 201) {
            setSubmitStatus("success")
            return
        }
        if (res.code === "ERR_NETWORK") {
            setSubmitStatus("ERR_NETWORK")
            return
        }
        setSubmitStatus("failed")

    }

    return (
        <Form className={"p-3"} method="post" onSubmit={handleSubmit(onSubmit)}>
            {formFields.map(
                ({
                     name,
                     label,
                     type,
                     required,
                     read_only,
                     cols,
                     rows,
                     choices,
                     help_text
                 }, index) => {

                    const FormTag = formEnum[type];
                    console.log(help_text)
                    return <>
                        <FormTag
                            key={name}
                            name={name}
                            label={label}
                            required={required}
                            choices={choices}
                            cols={cols}
                            rows={rows}
                            register={register}
                        >
                            <HelpText text={help_text}/>
                        </FormTag>
                        <ErrorMessage
                            errors={errors}
                            name="name"
                            render={({message}) => <p className={"text-danger"}>
                                <CgDanger/>入力が必須の項目です
                            </p>}
                        />
                    </>
                })}
            <SubmitButton
                submitStatus={submitStatus}
                message={"送信"}
            />
        </Form>

    );
}

export default App;
